import React, { useEffect, useState } from "react";
import { getLabelDate, hourFormat } from "functions/functions";
import CardItemEventoCalendario from "../cardItemEventoCalendario/cardItemEventoCalendario";
import "./cardEventoCalendario.sass";

const CardEventoCalendario = React.memo(({
  mostrarTodos,
  setMostrarTodos,
  id,
  titulo,
  items,
  fechaInicio,
  fechaFin,
  sportCode,
  arrayMostrar,
  setArrayMostrar,
  fechaAnterior,
}) => {
  const [frontDay, setFrontDay] = useState('');

  useEffect(() => {
    const newFrontDay = getLabelDate(fechaInicio);
    if (newFrontDay !== getLabelDate(fechaAnterior) && newFrontDay !== frontDay) {
      setFrontDay(newFrontDay);
    }
  }, [fechaInicio, fechaAnterior, frontDay]);

  // on click abrir - cerrar tarjeta
  const handleClickAbrirTarjeta = (idTarjeta) => {
    // Verifica si el ID ya está en el array
    if (arrayMostrar.includes(idTarjeta)) {
      setArrayMostrar(arrayMostrar.filter((id) => id !== idTarjeta));
      setMostrarTodos(false);
    } else {
      // Si no está en el array, lo agrega para mostrar la tarjeta "card-evento-lista-participantes"
      setArrayMostrar([...arrayMostrar, idTarjeta]);
    }
  };

  return (
    <div className="section-evento" id="section-evento-general" key={id} >

      <div className={frontDay.length === 0 && !arrayMostrar.includes(id) ? "stepper-evento" : arrayMostrar.includes(id) ? "stepper-evento marginB-10" :"stepper-evento margin0stepper"}>
        <div className="card-evento-dia-horario">

          {(frontDay && frontDay !== getLabelDate(fechaAnterior)) && <div className="card-evento-dia">
            <p className="label-dia">{frontDay}</p>
          </div>
          }

          <div className="card-evento-horario">
            <p>{hourFormat(fechaInicio)}</p>
            <p className="separador-horario">-</p>
            <p>{hourFormat(fechaFin)}</p>
          </div>

          <div className={arrayMostrar.includes(id) ? "card-circle active" : "card-circle inactive"}></div>

        </div>
      </div>

      <div  className={!arrayMostrar.includes(id) ? "card-completa-evento": "card-completa-evento marginB-10"} >
        <div className="card-evento" id="card-evento-general" onClick={() => handleClickAbrirTarjeta(id)}>
          <div className="card-evento-icono">
            <i className={`AMX-${sportCode}`}></i>
          </div>
          <div className="card-evento-titulo">
            <div className="card-evento-titulo-p">{titulo}</div>

            <div className="arrows-evento">
              <p>{items ? items.length : 0}</p>
              <div className={mostrarTodos || (arrayMostrar.length !== 0 && arrayMostrar.includes(id)) ? "arrow-top" : "arrow-bottom"}
              ></div>
            </div>
          </div>
        </div>

        {((arrayMostrar.length !== 0 && arrayMostrar.includes(id) && !mostrarTodos) ||
          (mostrarTodos && arrayMostrar.includes(id) && arrayMostrar.length !== 0))
          &&
          items && items.map((item) =>
            <CardItemEventoCalendario id={id} sportCode={sportCode} hourFormat={hourFormat} arrayMostrar={arrayMostrar} item={item} />
          )
        }
      </div>

      <div className={"stepper-evento-bottom"}>
        <div className="final-line"></div>
      </div>
    </div>
  );
})

export default CardEventoCalendario;